<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.material"
            ref="RkmDataTable"
            sort-by="nome"
        >
            <template v-slot:cell(conectasusMaterialDescricaoCompleta)="{item}">
                <template v-if="item.conectasusMaterialDescricaoCompleta">
                    {{ item.conectasusMaterialDescricaoCompleta }}
                </template>

                <rkm-button
                    v-else
                    @click="$refs.ModalVinculoConectaSusMaterial.open(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-material"
                    color="primary"
                    small
                >
                    Vincular material
                </rkm-button>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="edit(item.id)"
                    authorize="edit-web-service-almoxarifado-cliente-material"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(item)"
                    authorize="destroy-web-service-almoxarifado-cliente-material"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <ModalVinculoConectaSusMaterial
            @saved="$refs.RkmDataTable.refresh()"
            ref="ModalVinculoConectaSusMaterial"
        />
    </div>
</template>

<script>
// Components.
import ModalVinculoConectaSusMaterial from './components/vinculo-conecta-sus-material/Modal'

// Mixins.
import {error, repository} from '@/mixins'

export default {
    components: {ModalVinculoConectaSusMaterial},
    created() {
        this.repositories = {
            material: this.getConectaSusRepository('webService.almoxarifado.cliente.material'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'material.nome', searchable: true, sortable: true},
            {
                key: 'conectasusMaterialDescricaoCompleta',
                label: 'Material (ConectaSUS)',
                name: 'conectasusMaterialDescricaoCompleta',
                searchable: true,
                sortable: true
            },
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        edit(id) {
            this.$router.push({name: 'web-service-almoxarifado-cliente-material-edit', params: {id}})
        },
        destroy(item) {
            const destroy = () => this.repositories.material.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o material?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>